module.exports = __webpack_public_path__ + "static/media/img3-1.05f64efa.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/agave/nutricheck_foliar/P/img3-1.png
// module id = 1053
// module chunks = 3